import { render, staticRenderFns } from "./field-values.component.vue?vue&type=template&id=94392f66&scoped=true"
import script from "./field-values.component.vue?vue&type=script&lang=ts"
export * from "./field-values.component.vue?vue&type=script&lang=ts"
import style0 from "./field-values.component.vue?vue&type=style&index=0&id=94392f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94392f66",
  null
  
)

export default component.exports